import { DATASOURCE } from 'Constants'

const initialState = {
  data: [], 
  loading: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case DATASOURCE.PACKET_DATA_S.RESET:
      return {
        ...state,
        loading:false,
        data:[]
      };
    case DATASOURCE.PACKET_DATA_S.LOADING:
      return {
        ...state,
        loading: true,
        data:[] 
      };
    case DATASOURCE.PACKET_DATA_S.KEY:
      return {
        ...state,
        data: process(action.data),
        loading: false
      };
    default:
      return state;
  }
}

function process(data) {
  let inbound = {name: "To RealConnect", data:[]};  
  let outbound = {name: "From RealConnect", data:[]};  
  let output = [inbound,outbound];
  if (!data.aggregations || !data.aggregations.lossPerMinute ||     
      !data.aggregations.lossPerMinute.buckets || data.aggregations.lossPerMinute.buckets.length <= 1) {                                                                
    return output;                                                  
  }                                                                                   
  let buckets = data.aggregations.lossPerMinute.buckets;                              
  buckets.forEach( bucket => {    
    if (bucket.inboundDerivative && bucket.inboundDerivative.value >= 0)  
    {   
      inbound.data.push([bucket.key,bucket.inboundDerivative.value]);  
    }                                                                                
    if (bucket.outboundDerivative && bucket.outboundDerivative.value >= 0)  
    {   
      outbound.data.push([bucket.key,bucket.outboundDerivative.value]);   
    }  
  });                                                                                  
  return output;  
}
